module.exports = __webpack_public_path__ + "static/media/builderContentTwo.b11fb910.svg";